import { NgModule } from '@angular/core';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import { ComponentsModule } from './components/components.module';
import { ServicesModule } from './services/services.module';
import { PipesModule } from './pipes/pipes.module';
import { DirectivesModule } from './directives/directives.module';

export function playerFactory(): Promise<typeof import('lottie-web/build/player/lottie_svg')> {
  return import(/* webpackChunkName: 'lottie-web' */ 'lottie-web/build/player/lottie_svg');
}

@NgModule({
  imports: [
    ComponentsModule,
    DirectivesModule,
    ServicesModule,
    PipesModule
  ],
  exports: [
    ComponentsModule,
    DirectivesModule,
    ServicesModule,
    PipesModule
  ],
  providers: [
    provideLottieOptions({ player: playerFactory }),
    provideCacheableAnimationLoader()
  ]
})
export class CoreModule {
}
